import { Outlet } from "react-router";
import { RouteRestore } from "@/lib/utils/route-restore";
import { RouteSync } from "@/lib/utils/route-sync";
import { ErrorLayout } from "./error-layout";

export function RootLayout() {
  return (
    <ErrorLayout>
      <RouteRestore />
      <RouteSync />
      <Outlet />
    </ErrorLayout>
  );
}
